export * from './catalog-layers-list.component';
export * from './catalog-layers-list-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-layers-list/index.ts